/**
 * Fordonskort från dashboard-widgetar: bara Admin, Fleet Manager och global admin.
 */

export interface VehicleCardAccessUser {
  roleCodes?: string[];
  role?: string;
  is_global_admin?: boolean | number | string;
}

const CARD_ROLES = new Set(['ADMIN', 'FLEET_MANAGER']);

export function userMayOpenVehicleCard(user: VehicleCardAccessUser | null | undefined): boolean {
  if (!user) return false;
  const flag = user.is_global_admin;
  if (flag === true || flag === 1 || flag === '1') return true;
  const codes = Array.isArray(user.roleCodes) ? user.roleCodes : [];
  if (codes.some((code) => CARD_ROLES.has(code))) return true;
  return user.role != null && CARD_ROLES.has(user.role);
}
